import { useState } from 'react'
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { ContactCombobox } from '../../agreements/ContactCombobox'
import type { Ref } from '../../agreements/types'

/** Step one of "Samenvoegen met…" on the contact page: pick the other contact. */
export function PickContactDialog({
  excludeId,
  onClose,
  onPicked,
}: {
  excludeId: string
  onClose: () => void
  onPicked: (personId: string) => void
}) {
  const [choice, setChoice] = useState<Ref | null>(null)
  return (
    <Dialog open onOpenChange={(next) => (next ? undefined : onClose())}>
      <DialogContent size="sm">
        <DialogHeader>
          <DialogTitle>Samenvoegen met…</DialogTitle>
          <DialogDescription>Kies het contact dat je met dit contact wilt samenvoegen.</DialogDescription>
        </DialogHeader>
        <ContactCombobox
          label="Ander contact"
          value={choice}
          excludeId={excludeId}
          onChange={(picked) => {
            setChoice(picked)
            if (picked) onPicked(picked.id)
          }}
        />
      </DialogContent>
    </Dialog>
  )
}
